// extracted by mini-css-extract-plugin
export default {"pollContainer":"PollMessage__pollContainer___coWrM","pollMessageFooter":"PollMessage__pollMessageFooter___YESv0"};